<style scoped>
 div.panel-parent-00 {
   margin-top: 30px;
   padding: 0 20px;
 }
 div.patch_name_property {
   widht: 860px;
   margin-bottom: 20px;
 }
 div.debug-tool-area {
   background-color: #FFCCBC;
 }
 .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 0 16px 0!important;
 }
 .title-text-color {
   color: #666666;
 }
 .toUpperCase {
   text-transform: uppercase;
 }
 .space-at-the-end {
   margin-bottom: 60px;
 }
</style>
<template>
  <div class="panel-parent-00 space-at-the-end">
    <!-- https://vuetifyjs.com/en/components/expansion-panels/#model -->
    <MidiDeviceControls ref="MidiDeviceControls"/>

      <!-- vvv content controller v -->
      <div class="ewi4000editor-parent-00 justify-align-center direction-column">
        <div class="ewi4000editor-parent-01">
          <div>
            <div class="patch_name_property">
              <v-row>
                <v-col cols="8">
                  <PatchNumNameCard v-if="paint_panel.patchNameCard" label="patchNameCard" :patchnameparam="patchnumname" ref="PatchNumNameCard"/>
                </v-col>
                <v-col cols="4">
                  <PatchAction ref="PatchAction"/>
                </v-col>
              </v-row>
            </div>

            <!--
            <div class="justify-align-center direction-row">
              <v-alert
                  dense
                  outlined
                  color="red">
                <div class="justify-align-center">
                  <v-icon color="red">mdi-alert</v-icon> &nbsp; <strong>DEBUG TOOLS</strong> &nbsp;<v-icon color="red">mdi-alert</v-icon>
                </div>
                <div class="justify-align-center">
                  <v-btn icon @click="repaintAllPanel()"><v-icon small color="red">mdi-format-paint</v-icon></v-btn>
                  <v-btn icon @click="dumpAllPatches()"><v-icon small color="red">mdi-code-parentheses</v-icon></v-btn>
                  <v-btn icon @click="dumpDiffPatches()"><v-icon small color="red">mdi-vector-difference</v-icon></v-btn>
                  <v-btn icon @click="callRevealSysExDiff()"><v-icon small color="red">mdi-compare-horizontal</v-icon></v-btn>
                </div>
              </v-alert>
            </div>
            -->

            <v-expansion-panels
                v-model="statusExpandPanel"
                multiple
                focusable
                :disabled="enableControl"
            >
              <!--
                coloar="#194e6e"
                   disabled
                 -->
            <!-- v-expansion-panels v-model="status_expand_panel" multiple focusable accordion-->

              <!-- -->
              <v-expansion-panel key="3" @click="onChangeAuditionPanel()" :disabled="demoMode">
                <v-expansion-panel-header
                    :style="header_background_color.effects"
                    id="panel_2"
                    class="font-weight-bold toUpperCase"
                    color="indigo lighten-5"><div class="title-text-color"><v-icon>mdi-music-circle</v-icon> &nbsp; Audition</div></v-expansion-panel-header>
                <v-expansion-panel-content :style="content_background_color.audition">
                  <Audition v-if="paint_panel.audition" :label="auditionparam.label" ref="Audition"/>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- -->


              <!-- -->
              <v-expansion-panel key="0">
                <v-expansion-panel-header
                    :style="header_background_color.osc1"
                    id="panel_0"
                    class="font-weight-bold toUpperCase"
                    color="indigo lighten-5"><div class="title-text-color"><v-icon>mdi-sine-wave</v-icon> &nbsp; Oscillators</div></v-expansion-panel-header>
                <v-expansion-panel-content
                    :style="content_background_color.osc1">
                  <div class="each-controller-top justify-align-center direction-row">
                    <RackMounterKit mounterheigth="175" mounterwidth="58" position="left"/>
                    <div class="between_panel-00"></div>
                    <Oscillator v-if="paint_panel.osc1" parameter_group_title="OSC1" :label="osc1param.label" :oscparam="osc1param.param" :xfade_button="Boolean(false)"/>
                    <div class="between_panel-00"></div>
                    <RackMounterKit mounterheigth="175" mounterwidth="220" position="right"/>
                  </div>
                  <div class="each-controller-00 justify-align-center direction-row">
                    <RackMounterKit mounterheigth="175" mounterwidth="58" position="left"/>
                    <div class="between_panel-00"></div>
                    <Oscillator v-if="paint_panel.osc2" parameter_group_title="OSC2" :label="osc2param.label" :oscparam="osc2param.param" :xfade_button="Boolean(true)"/>
                    <div class="between_panel-00"></div>
                    <RackSpacerKit spacerheigth="175" spacerwidth="20"/>
                    <div class="between_panel-00"></div>
                    <Formant v-if="paint_panel.formant" parameter_group_title="FORMANT"
                             :label="formant.label" :filter_items="formant.filter_items" :formantparam="formant.param"/>
                    <div class="between_panel-00"></div>
                    <RackMounterKit mounterheigth="175" mounterwidth="58" position="right"/>
                  </div>

                  <div class="each-controller-00 justify-align-center direction-row">
                    <NOFilter v-if="paint_panel.oscFilter1" parameter_group_title="OSC FILTER 1"
                              filter_link_name="oscFilter"
                              :label="oscFilter1param.label" :select_items="oscFilter1param.select_items"
                              :mode_items="oscFilter1param.mode_items" :filterparam="oscFilter1param.param"
                              :secondary="false"/>
                    <div class="between_panel-00"></div>
                    <NOFilter v-if="paint_panel.oscFilter2" parameter_group_title="OSC FILTER 2"
                              filter_link_name="oscFilter"
                              :label="oscFilter2param.label" :select_items="oscFilter2param.select_items"
                              :mode_items="oscFilter2param.mode_items" :filterparam="oscFilter2param.param"
                              :secondary="true"/>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- -->

              <!-- -->
              <v-expansion-panel key="1">
                <v-expansion-panel-header
                    :style="header_background_color.osc1"
                    id="panel_0"
                    class="font-weight-bold toUpperCase"
                    color="indigo lighten-5"><div class="title-text-color"><v-icon>mdi-blur</v-icon> &nbsp; Noise & Effects</div></v-expansion-panel-header>
                <v-expansion-panel-content :style="content_background_color.osc1">
                  <div class="each-controller-top justify-align-center direction-row">
                    <RackMounterKit mounterheigth="175" mounterwidth="90" position="left"/>
                    <div class="between_panel-00"></div>
                    <Noisegen v-if="paint_panel.noiseGen" parameter_group_title="NOISE GEN"
                              :label="noiseGen.label" :noisegenparam="noiseGen.param"/>
                    <div class="between_panel-00"></div>
                    <RackSpacerKit spacerheigth="175" spacerwidth="88"/>
                    <div class="between_panel-00"></div>
                    <Effects v-if="paint_panel.effects" parameter_group_title="EFFECTS"
                             :label="effects.label" :effectsparam="effects.param" :select_items="effects.select_items"/>
                    <div class="between_panel-00"></div>
                    <RackMounterKit mounterheigth="175" mounterwidth="90" position="right"/>
                  </div>
                  <!-- -->
                  <div class="each-controller-00 justify-align-center direction-row">
                    <NOFilter v-if="paint_panel.noiseFilter1" parameter_group_title="NOISE FILTER 1"
                              filter_link_name="noiseFilter"
                              :label="noiseFilter1param.label" :select_items="noiseFilter1param.select_items"
                              :mode_items="noiseFilter1param.mode_items" :filterparam="noiseFilter1param.param"
                              :secondary="false"/>
                    <div class="between_panel-00"></div>
                    <NOFilter v-if="paint_panel.noiseFilter2" parameter_group_title="NOISE FILTER 2"
                              filter_link_name="noiseFilter"
                              :label="noiseFilter2param.label" :select_items="noiseFilter2param.select_items"
                              :mode_items="noiseFilter2param.mode_items" :filterparam="noiseFilter2param.param"
                              :secondary="true"/>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- -->

              <!-- -->
              <v-expansion-panel key="2">
                <v-expansion-panel-header
                    :style="header_background_color.effects"
                    id="panel_2"
                    class="font-weight-bold toUpperCase"
                    color="indigo lighten-5"><div class="title-text-color"><v-icon>mdi-puzzle</v-icon> &nbsp; Common & Amp</div></v-expansion-panel-header>
                <v-expansion-panel-content :style="content_background_color.effects">
                  <div class="each-controller-top justify-align-center direction-row">
                    <RackMounterKit mounterheigth="175" mounterwidth="158" position="left"/>
                    <div class="between_panel-00"></div>
                    <Common v-if="paint_panel.common" parameter_group_title="COMMON"
                            :label="common.label" :keyTrigger_items="common.keyTrigger_items" :commonparam="common.param"/>
                    <div class="between_panel-00"></div>
                    <RackSpacerKit spacerheigth="175" spacerwidth="158"/>
                    <div class="between_panel-00"></div>
                    <Amp v-if="paint_panel.amp" parameter_group_title="AMP" :label="amp.label" :ampvalue="amp.param.ampLevel"/>
                    <div class="between_panel-00"></div>
                    <RackMounterKit mounterheigth="175" mounterwidth="158" position="right"/>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- -->

            </v-expansion-panels>
          </div>

        </div>
      </div>

      <!--
      <div class="justify-align-center direction-row">
        <div style="width: 100px">
          [{{ rePaintFilterPanel | toString }}] [{{ workingPatchIdx | NumToStr }}]
        </div>
        <div style="width: 100px">
          <v-text-field v-model="rePaintFilterPanel" readonly></v-text-field>
        </div>
      </div>
      -->
  </div>

</template>

<script>
 import MidiDeviceControls from './MidiDeviceControls.vue'
 import Audition from './Audition.vue'
 import PatchNumNameCard from './PatchNumNameCard.vue'
 import PatchAction from './PatchAction.vue'
 import Oscillator from './Oscillator.vue'
 import NOFilter from './NOFilter.vue'
 import Noisegen from './Noisegen.vue'
 import Formant from './Formant.vue'
 import Amp from './Amp.vue'
 import Common from './Common.vue'
 import Effects from './Effects.vue'
 import RackMounterKit from './RackMounterKit.vue'
 import RackSpacerKit from './RackSpacerKit.vue'

 import { sample_patches } from '../../sample_patches/sample02.js';

 export default {
   name: 'EWI4000Editor',
   props: [],
   components: {
     Audition,
     MidiDeviceControls,
     PatchNumNameCard,
     PatchAction,
     Oscillator,
     NOFilter,
     Noisegen,
     Formant,
     Amp,
     Common,
     Effects,
     RackMounterKit,
     RackSpacerKit,
   },
   filters: {
     toString: function(val) {
       if (val == '' || val == null) return '--'
       return val===true ? 'TRUE' : 'FALSE'
     },
     NumToStr: function(val) {
       if (typeof val != 'number') return '00'
       return `00${val}`.substr(-2)
     }
   },
   mounted: function() {
     this.$refs.MidiDeviceControls.handleDeviceCommunicationDialog(true)
     setTimeout( () => {
       this.$store.commit('onUpdateLoadingSplashShow', {value: false})
     }, 2500)
   },
   created: function() {
     const init_patchList = this.createEmptyPatchList()
     if (this.debugMode) {
       this.switchDemoDevicePatches()
     } else {
       this.$store.commit('onInitPatchList', {data: init_patchList})
     }
   },
   methods: {
     repaintAllPanel: function() {
       console.log('[Fired] repaintAllPanel:EWI4000Editor.vue')
       Object.keys(this.paint_panel).forEach( key => {
         this.repaintPanel.bind(this)(key)
       })
       /*
       updateState.bind(this)(false)
       this.$nextTick( () => {
         updateState.bind(this)(true)
       })
       function updateState(state=true) {
         Object.keys(this.paint_panel).forEach( key => {
           this.paint_panel[key] = state
         })
       }
       */
     },
     repaintPanel: function(name=null) {
       if (name==null) return
       console.log('[Fired] repaintPanel:EWI4000Editor.vue')
       this.paint_panel[name] = false
       this.$nextTick( () => {
         this.paint_panel[name] = true
       })
     },
     onChangeAuditionPanel: function() {
       let timerId = setInterval( () => {
         if (typeof this.$refs.Audition != 'undefined') {
           clearInterval(timerId)
           this.$refs.Audition.forceSetParam(64)
         }
         this.repaintPanel('audition')
       }, 100)
     },
     dumpAllPatches: function() {
       const edit = this.$store.getters.getAllEditedPatch()
       const stored = this.$store.getters.getAllStoredPatch()
       console.log('[idx] [edited] [stored]')
       edit.forEach( (item, idx) => {
         console.log(idx, item.decoded, stored[idx].decoded)
       })
     },
     dumpDiffPatches: function() {
       //console.log(this)
       this.$refs.PatchAction.updateParamIsSynced()
     },
     callRevealSysExDiff() {
       this.$refs.MidiDeviceControls.revealSysExDiff()
       this.dumpDiffPatches()
     },
     createEmptyPatchList: function() {
       const init_patchList = new Array(100)
       for (let idx=0; idx<init_patchList.length; idx++) {
         const one_Patch = {
           decoded: {
             patchNo: idx,
             patchNameDecoded: '---',
             fetched: false,
             isSynced: false,
             link: true,
           },
           hex: new Uint8Array()
         }
         init_patchList[idx] = one_Patch
       }
       return init_patchList
     },
     switchDemoDevicePatches: function(loadDemo=true) {
       const init_patchList = this.createEmptyPatchList()
       console.log(`[DEBUG MODE] >>>>> ${this.debugMode} <<<<< {EWI4000Editor.vue}`)
       if (loadDemo) {
         sample_patches.forEach( (obj_param, idx) => {
           init_patchList[idx] = obj_param
         })
       }
       this.$store.commit('onInitPatchList', {data: init_patchList})
       //return init_patchList
     },
     // [DO NOT REMOVE] refered from outside of this component
     closePanels: function() {
       console.log(this.$data.status_expand_panel)
       this.$store.commit('onUpdateStatusExpandPanel', {value: []})
     },
     // _filterType: target filter name
     applyNOFilterParamToUi(_patchNo = null, _filterType=null, rePaint=false) {
       const working_idx = _patchNo!=null ? _patchNo : this.$store.getters.getWorkingPatchIdx()
       if (working_idx > 99 || working_idx < 0) return

       const patch = this.$store.getters.getOneEditPatch(working_idx)

       const filterTypeList = this.filterTypeList
       let filterType =_filterType
       if (filterType.match(/param$/)==null) {
         filterType = `${filterType}param`
       }

       if (!filterTypeList.includes(filterType)) return
       //console.log(`_patchNo=[${_patchNo}] filterType=[${filterType}] rePaint=[${rePaint}]`)
       //console.log('patch',patch)

       // copy Filterparam
       const filterTypeDecoded = filterType.replace(/param$/, 'Decoded')
       //console.log(`applyNOFilterParamToUi: filterType=[${filterType}], filterTypeDecoded=[${filterTypeDecoded}]`)
       Object.keys(this.$data[`${filterType}`].param).forEach( key => {
         this.$set(this.$data[`${filterType}`].param, key, patch.decoded[`${filterTypeDecoded}`][key])
         //console.log(`applyNOFilterParamToUi key=[${key}] param=[${patch.decoded[`${filterTypeDecoded}`][key]}]`, patch.decoded['oscFilterLink'])
       })
       this.$set(this.$data[`${filterType}`].param, 'mode', this.$data[`${filterType}`].param.mode)

       if (rePaint) {
         this.paint_panel[_filterType] = false
         this.$nextTick( () => {
           this.paint_panel[_filterType] = true
         })
         console.log(_filterType, this.paint_panel[_filterType])
       }
     },
     applyParamToUi(_patchNo = null) {
       return new Promise( (resolve, reject) => {
         const working_idx = _patchNo!=null ? _patchNo : this.$store.getters.getWorkingPatchIdx()
         if (working_idx > 99 || working_idx < 0) reject(new Error()) //return false

         const patch = this.$store.getters.getOneEditPatch(working_idx)
         if (typeof patch.decoded.fetched != 'undefined') {
           if (patch.decoded.fetched===false) {
             reject(new Error())
             return
           }
         }

         //console.log(`[applyParamToUi:EWI4000Editor.vue] working_idx=[${working_idx}] fetched=[${patch.decoded.fetched}]`)
         //console.log('[decoded:EWI4000Editor.vue]', patch.decoded)
         //console.log(`[isSynced:EWI4000Editor.vue] ${patch.decoded.isSynced}`)

         // patch num name
         this.$set(this.$data.patchnumname, 'num', working_idx)
         this.$set(this.$data.patchnumname, 'name', patch.decoded.patchNameDecoded)
         this.$set(this.$data.patchnumname, 'isSynced', patch.decoded.isSynced)

         // osc1param, osc2param
         Object.keys(this.$data.osc1param.param).forEach( key => {
           this.$set(this.$data.osc1param.param, key, patch.decoded.osc1Decoded[key])
           this.$set(this.$data.osc2param.param, key, patch.decoded.osc2Decoded[key])
         })

         const x_fade_val = patch.decoded.osc2Xfade[0] === 0 ? false : true
         this.$set(this.$data.osc1param.param, 'x_fade', x_fade_val)
         this.$set(this.$data.osc2param.param, 'x_fade', x_fade_val)

         //this.$store.commit('onEditOneEditPatch', {arr_idx: ['osc1Decoded', 'x_fade'], value: x_fade_val})
         //this.$store.commit('onEditOneEditPatch', {arr_idx: ['osc2Decoded', 'x_fade'], value: x_fade_val})
         this.$store.commit('onEditOneEditPatch', {arr_idx: ['osc2Xfade'], value: Uint8Array.from((x_fade_val) ? [1] : [0] )})

         // filters
         const filterTypeList = this.filterTypeList
         filterTypeList.forEach( filterType => {
           this.applyNOFilterParamToUi(working_idx, filterType)
         })

         // noisegen
         this.$set(this.$data.noiseGen.param, 'noiseTime', patch.decoded.noiseTime[0])
         this.$set(this.$data.noiseGen.param, 'noiseBreath', patch.decoded.noiseBreath[0])
         this.$set(this.$data.noiseGen.param, 'noiseLevel', patch.decoded.noiseLevel[0])

         // formant
         this.$set(this.$data.formant.param, 'formantFilter',
                   this.$data.formant.filter_items[patch.decoded.formantFilter[0]])

         // amp
         this.$set(this.$data.amp.param, 'ampLevel', patch.decoded.ampLevel[0])

         // common
         this.$set(this.$data.common.param, 'keyTrigger',
                   this.$data.common.keyTrigger_items[patch.decoded.keyTrigger[0]])
         this.$set(this.$data.common.param, 'bendRange', patch.decoded.bendRange[0])
         this.$set(this.$data.common.param, 'bendStepMode',
                   (patch.decoded.bendStepMode[0]===0) ? false : true)
         this.$set(this.$data.common.param, 'biteVibrato', patch.decoded.biteVibrato[0])
         this.$set(this.$data.common.param, 'biteTremolo', patch.decoded.biteTremolo[0])
         this.$set(this.$data.common.param, 'octaveLevel', patch.decoded.octaveLevel[0])

         // effect
         this.$set(this.$data.effects.param, 'chorusSwitch',
                   (patch.decoded.chorusSwitch[0]===0) ? false : true)
         this.$set(this.$data.effects.param, 'chorusFeedback', patch.decoded.chorusFeedback[0])
         this.$set(this.$data.effects.param, 'chorusDelay1', patch.decoded.chorusDelay1[0])
         this.$set(this.$data.effects.param, 'chorusLFOfreq', patch.decoded.chorusLFOfreq[0])
         this.$set(this.$data.effects.param, 'chorusModLev1', patch.decoded.chorusModLev1[0])
         this.$set(this.$data.effects.param, 'chorusDryLevel', patch.decoded.chorusDryLevel[0])
         this.$set(this.$data.effects.param, 'chorusWetLev1', patch.decoded.chorusWetLev1[0])
         this.$set(this.$data.effects.param, 'chorusDelay2', patch.decoded.chorusDelay2[0])
         this.$set(this.$data.effects.param, 'chorusModLev2', patch.decoded.chorusModLev2[0])
         this.$set(this.$data.effects.param, 'chorusWetLev2', patch.decoded.chorusWetLev2[0])
         this.$set(this.$data.effects.param, 'delayTime', patch.decoded.delayTime[0])
         this.$set(this.$data.effects.param, 'delayDamp', patch.decoded.delayDamp[0])
         this.$set(this.$data.effects.param, 'delayFeedback', patch.decoded.delayFeedback[0])
         this.$set(this.$data.effects.param, 'delayLevel', patch.decoded.delayLevel[0])
         this.$set(this.$data.effects.param, 'reverbTime', patch.decoded.reverbTime[0])
         this.$set(this.$data.effects.param, 'reverbDamp', patch.decoded.reverbDamp[0])
         this.$set(this.$data.effects.param, 'reverbDensity', patch.decoded.reverbDensity[0])
         this.$set(this.$data.effects.param, 'reverbLevel', patch.decoded.reverbLevel[0])

         // re-paint panel
         __toggleShowUi.bind(this)(false)

         this.$nextTick( () => {
           __toggleShowUi.bind(this)(true)
         })
         function __toggleShowUi(mode=false) {
           Object.keys(this.paint_panel).forEach( key => {
             this.paint_panel[key] = mode
           })
         }
         resolve()
       })

     }
   },
   computed: {
     demoMode: {
       get: function() {
         return this.$store.getters.getDemoMode()
       },
       set: function() {}
     },
     enableControl: {
       get: function() {
         // cloase all panels
         this.$store.commit('onUpdateStatusExpandPanel', {value: []})
         if (typeof this.$refs.PatchNumNameCard != 'undefined') {
           this.$refs.PatchNumNameCard.clearPatchNamePatchNo()
         }
         return !this.$store.getters.getEnableControl()
       }
     },
     storedPatchList: {
       get: function() {
         return this.$store.getters.getAllStoredPatch()
       }
     },
     workingPatchIdx: {
       get: function() {
         return this.$store.getters.getWorkingPatchIdx()
         //return this.$store.getters.getWorkingPatch()
       }
     },
     editPatchList: {
       get: function() {
         return this.$store.getters.getAllEditdPatch()
       }
     },
     statusExpandPanel: {
       get: function() {
         return this.$store.getters.getStatusExpandPanel()
       },
       set: function(newValue) {
         this.$store.commit('onUpdateStatusExpandPanel', {value: newValue})
       }
     },
   },
   watch: {
     /*
     statusExpandPanel() {
       if (this.$store.getters.getStatusExpandPanel().length==0) {
         //this.status_expand_panel = []
       }
     },
      */
     async workingPatchIdx() {
       const workingPatch = this.$store.getters.getWorkingPatch()
       //console.log(workingPatch.idx)
       //this.applyParamToUi.bind(this)(workingPatch.idx)
       try {
         await this.applyParamToUi.bind(this)(workingPatch.idx)
       } catch (err) {
         console.log('[watch - workingPatchIdx:EWI4000Editor.vue]', err)
       }
     },
     storedPatchList() {
       //console.log('EWI4000Editor.vue:watch.storedPatchList')
     },
   },
   data: () => ({
     debugMode: false,
     //
     items: [
       { title: 'Home', icon: 'mdi-home-city' },
       { title: 'My Account', icon: 'mdi-account' },
       { title: 'Users', icon: 'mdi-account-group-outline' },
     ],
     mini: true,
     //
     header_background_color: {
       osc1: 'background-color: #FAFAFA',
       osc2: 'background-color: #FAFAFA',
       effects: 'background-color: #FAFAFA',
       others: 'background-color: #FAFAFA',
     },
     content_background_color: {
       audition: 'background-color: rgba(172,176,168)',
       osc1: 'background-color: rgba(172,176,168)',
       osc2: 'background-color: rgba(172,176,168)',
       effects: 'background-color: rgba(172,176,168)',
       others: 'background-color: rgba(172,176,168)',
     },
     paint_panel: {
       audition: true,
       patchNameCard: true,
       osc1: true,
       osc2: true,
       oscFilter1: true,
       noiseFilter1: true,
       oscFilter2: true,
       noiseFilter2: true,
       noiseGen: true,
       formant: true,
       common: true,
       effects: true,
       amp: true
     },
     filterTypeList: ['oscFilter1param', 'oscFilter2param', 'noiseFilter1param', 'noiseFilter2param'],
     expand_panel: [],
     patchnumname: {
       num: '',
       name: '',
       isSynced: true
     },
     auditionparam: {
       label: 'audition',
     },
     osc1param: {
       label: 'osc1',
       param: {
         nrpn: null,
         octave: 0,
         fine: 0,
         semitone: 0,
         beat: 0,
         sawtooth: 0,
         triangle: 0,
         square: 0,
         pulseWidth: 0,
         pwmFreq: 0,
         pwmDepth: 0,
         sweepTime: 0,
         sweepDepth: 0,
         breathAttain: 0,
         breathDepth: 0,
         breathThreshold: 0,
         breathCurve: 0,
         x_fade: false,
         level: 0
       }
     },
     osc2param: {
       label: 'osc2',
       param: {
         octave: 0,
         fine: 0,
         semitone: 0,
         beat: 0,
         sawtooth: 0,
         triangle: 0,
         square: 0,
         pulseWidth: 0,
         pwmFreq: 0,
         pwmDepth: 0,
         sweepTime: 0,
         sweepDepth: 0,
         breathAttain: 0,
         breath_depth: 0,
         breathThreshold: 0,
         breathCurve: 0,
         x_fade: false,
         level: 0
       }
     },
     oscFilter1param: {
       label: 'oscFilter1', // parameter name in 'ewi4000sdriver.js'
       select_items: [
         1, 2, 'LINK'
       ],
       mode_items: [
         { id: 0, text: 'LP'},
         { id: 1, text: 'HP'},
         { id: 2, text: 'BP'},
         { id: 3, text: 'NTC'},
         { id: 4, text: 'OFF'},
       ],
       param: {
         nrpn: 0,
         mode: 0,
         freq: 0,
         q: 0,
         keyFollow: 0,
         breathMod: 0,
         lfoFreq: 0,
         lfoDepth: 0,
         lfoBreath: 0,
         lfoThreshold: 0,
         sweepDepth: 0,
         sweepTime: 0,
         breathCurve: 0,
         link: false
       }
     },
     oscFilter2param: {
       label: 'oscFilter2', // parameter name in 'ewi4000sdriver.js'
       select_items: [
         1, 2, 'LINK'
       ],
       mode_items: [
         { id: 0, text: 'LP'},
         { id: 1, text: 'HP'},
         { id: 2, text: 'BP'},
         { id: 3, text: 'NTC'},
         { id: 4, text: 'OFF'},
       ],
       param: {
         nrpn: 0,
         mode: 0,
         freq: 0,
         q: 0,
         keyFollow: 0,
         breathMod: 0,
         lfoFreq: 0,
         lfoDepth: 0,
         lfoBreath: 0,
         lfoThreshold: 0,
         sweepDepth: 0,
         sweepTime: 0,
         breathCurve: 0,
         link: false
       }
     },
     noiseFilter1param: {
       label: 'noiseFilter1', // parameter name in 'ewi4000sdriver.js'
       select_items: [
         1, 2, 'LINK'
       ],
       mode_items: [
         { id: 0, text: 'LP'},
         { id: 1, text: 'HP'},
         { id: 2, text: 'BP'},
         { id: 3, text: 'NTC'},
         { id: 4, text: 'OFF'},
       ],
       param: {
         nrpn: 0,
         mode: 'NTC',
         freq: 0,
         q: 0,
         keyFollow: 0,
         breathMod: 0,
         lfoFreq: 0,
         lfoDepth: 0,
         lfoBreath: 0,
         lfoThreshold: 0,
         sweepDepth: 0,
         sweepTime: 0,
         breathCurve: 0,
         link: false
       }
     },
     noiseFilter2param: {
       label: 'noiseFilter2', // parameter name in 'ewi4000sdriver.js'
       select_items: [
         1, 2, 'LINK'
       ],
       mode_items: [
         { id: 0, text: 'LP'},
         { id: 1, text: 'HP'},
         { id: 2, text: 'BP'},
         { id: 3, text: 'NTC'},
         { id: 4, text: 'OFF'},
       ],
       param: {
         nrpn: 0,
         mode: 'NTC',
         freq: 0,
         q: 0,
         keyFollow: 0,
         breathMod: 0,
         lfoFreq: 0,
         lfoDepth: 0,
         lfoBreath: 0,
         lfoThreshold: 0,
         sweepDepth: 0,
         sweepTime: 0,
         breathCurve: 0,
         link: false
       }
     },
     noiseGen: {
       label: 'noiseGen',
       param: {
         noiseTime: 0,
         noiseBreath: 0,
         noiseLevel: 0
       }
     },
     formant: {
       label: 'formantFilter',
       filter_items: [
         { id: 0, text: 'OFF'},
         { id: 1, text: 'W.WIND'},
         { id: 2, text: 'STRING'},
       ],
       param: {
         formantFilter: 0
       }
     },
     amp: {
       label: 'amp',
       param: {
         ampLevel: 0
       }
     },
     common: {
       label: 'common',
       keyTrigger_items: [
         { id: 0, text: 'MULTI'},
         { id: 1, text: 'SINGLE'},
       ],
       param: {
         keyTrigger: 1,
         octaveLevel: 0,
         bendRange: 0,
         bendStepMode: 0,
         biteVibrato: 0,
         biteTremolo: 0, // VIBRATO:AMP
       }
     },
     effects: {
       label: 'effects',
       select_items: [
         1, 2
       ],
       param: {
         chorusSwitch: false,
         chorus_nrpn: 0,
         chorusFeedback: 0,
         chorusDelay1: 0,
         chorusLFOfreq: 0,
         chorusModLev1: 0,
         chorusDryLevel: 0,
         chorusWetLev1: 0,
         chorusDelay2: 0,
         chorusModLev2: 0,
         chorusWetLev2: 0,
         delayTime: 0,
         delayDamp: 0,
         delayFeedback: 0,
         delayLevel: 0,
         reverbTime: 0,
         reverbDamp: 0,
         reverbDensity: 0,
         reverbLevel: 0,
       }
     }
   }),
 }
</script>
